<script lang="ts">
    import ColumnOptions, {type ArrayFormatter, type Formatter} from 'Pages/PublicationPage/Views/ColumnOptions';

    export let options: ColumnOptions;
    export let item: any;
    export let key: string;
    export let config: { key: string, formatter?: Formatter | ArrayFormatter, extraComponent?: any };
    
    $: summaryFormatted = options.formatter?.(item[key]) ?? item[key];
    $: detailsFormatted = config.formatter?.(item[config.key]) ?? item[config.key];
    $: detailsIsArray = Array.isArray(detailsFormatted);
</script>

<details>
    <summary>
        {summaryFormatted}
    </summary>
    <p>
        {#if detailsIsArray}
            {#each detailsFormatted as line}
                {line}<br>
            {/each}
        {:else}
            {detailsFormatted}
        {/if}
    </p>
    {#if config.extraComponent !== undefined}
        <svelte:component this={config.extraComponent} item={item} />
    {/if}
</details>

<style>
    details {
        font-weight: normal;
        cursor: initial;
    }

    details p {
        margin: .8rem;
    }

    summary {
        cursor: pointer;
        font-weight: 600;
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 1.3rem;
        white-space: nowrap;
    }
</style>
